import http from '@/api/common'
export default {
  getIntegrations(searchOptions) {
    console.log('Get Integration Queue Data')
    return http.postWithJson('admin/integrationQueue', searchOptions)
  },
  getIntegrationById(id) {
    console.log('Get Integration Queue By Id')
    return http.get(`admin/integrationQueueById?id=${id}`)
  },
  requeueIntegrationById(id) {
    console.log('Requeue Integration Queue Data')
    console.log(id)
    return http.put(`admin/integrationQueue/requeue/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/integration.js